/* istanbul ignore file */
export enum SPACE_KEYS {
    /**
     * @value About
     */
    ABOUT_DIALOG_TITLE = 'FRONT.COMMUNITY.ABOUT_TITLE',
    /**
     * @value Description
     * @description Global key for the word "Description"
     */
    ABOUT_TAB_DESCRIPTION = 'GLOBAL.DESCRIPTION',
    /**
     * @value Members
     * @description Title of the members tab of the community configuration dialog
     *
     */
    ABOUT_TAB_MEMBERS = 'FRONT.COMMUNITY.CONFIGURATION_DIALOG.TAB.MEMBERS.TITLE',
    /**
     * @value Ask to join
     */
    ACCESS_REQUEST = 'SPACES.ACCESS_REQUEST',
    /**
     * @value Request sent
     */
    ACCESS_REQUEST_PENDING = 'SPACES.ACCESS_REQUEST_PENDING',
    /**
     * @value Space members do not automatically have access to the selected calendar.
     * Ensure that members (users and groups) of the space have access to the calendar directly in the service configuration.
     * @description "space" should not be translated, it is a male name.
     * In the Space configuration, message to warn admins when they are selecting a calendar.
     *
     */
    CALENDAR_ACCESS_WARNING = 'SPACES.CONFIGURATION_ACCESS_WARNING_CALENDAR',
    /**
     * @value You don't have access to this community.
     * @description Text used to inform the user that he can't view the community or space content on a private visibility
     */
    COMMUNITY_VISIBILITY_RESTRICTED = 'COMMUNITIES.COMMUNITY_VISIBILITY_RESTRICTED',
    /**
     * @value {"one":"%COUNT% metadata value selected","other":"%COUNT% metadata values selected"}
     */
    COUNT_METADATA_SELECTED_PLURALIZE = 'SPACES.COUNT_METADATA_SELECTED_PLURALIZE',
    /**
     * @value You have %DRAFT_POSTS% and %SCHEDULED_POSTS%
     * @description %DRAFT_POSTS% & %SCHEDULED_POSTS% are already pluralised.
     *
     * Examples:
     *
     * - You have 3 drafts and 1 scheduled posts
     * - You have 1 draft and 8 scheduled posts
     */
    DRAFT_AND_SCHEDULED_POST_LINKS = 'SPACES.DRAFT_AND_SCHEDULED_POST_LINKS',
    /**
     * @value Draft posts
     * @description Section title, to display a list of drafted posts
     */
    DRAFT_POSTS = 'SPACES.DRAFT_POSTS',
    /**
     * @value {"one":"You have %COUNT% post draft","other":"You have %COUNT% post drafts"}
     * @description Example:
     *
     * You have 2 posts drafts
     * You have 1 post draft
     */
    DRAFT_POST_LINK = 'SPACES.DRAFT_POST_LINK',
    /**
     * @value Space members do not automatically have access to the selected drive.
     * Ensure that members (users and groups) of the space have access to the drive directly in the service configuration.
     * @description "space" should not be translated, it is a male name.
     * In the Space configuration, message to warn admins when they are selecting a drive folder.
     */
    DRIVE_ACCESS_WARNING = 'SPACES.CONFIGURATION_ACCESS_WARNING_DRIVE',
    /**
     * @value This page gives you access to all posts draft created.
     */
    EMPTY_DRAFT_POST_LIST_MESSAGE = 'SPACES.EMPTY_DRAFT_POST_LIST_MESSAGE',
    /**
     * @value No post draft yet
     * @description empty message for a list of draft posts
     */
    EMPTY_DRAFT_POST_LIST_TITLE = 'SPACES.EMPTY_DRAFT_POST_LIST_TITLE',
    /**
     * @value This page gives you access to all scheduled posts created.
     */
    EMPTY_SCHEDULED_POST_LIST_MESSAGE = 'SPACES.EMPTY_SCHEDULED_POST_LIST_MESSAGE',
    /**
     * @value No scheduled post yet
     */
    EMPTY_SCHEDULED_POST_LIST_TITLE = 'SPACES.EMPTY_SCHEDULED_POST_LIST_TITLE',
    /**
     * @value Google Calendar
     */
    GOOGLE_CALENDAR = 'WIDGET_EVENT_METADATA.GOOGLE_CALENDAR',
    /**
     * @value Google Drive folder
     */
    GOOGLE_DRIVE_FOLDER = 'SPACES.CONFIGURATION_GOOGLE_DRIVE_FOLDER',
    /**
     * @value All articles
     * @description The label of the button to go to the article list in a space.
     */
    GO_TO_ARTICLE_LIST = 'SPACES.GO_TO_ARTICLE_LIST',
    /**
     * @value All events
     * @description The label of the button to go to the article list in a space.
     */
    GO_TO_EVENT_LIST = 'SPACES.GO_TO_EVENT_LIST',
    /**
     * @value Your site currently does not have any metadata available for spaces. Contact your site administrator to manage metadata.
     * @description Message for an empty state
     */
    METADATA_EMPTY_STATE_DESCRIPTION = 'SPACES.METADATA_EMPTY_STATE_DESCRIPTION',
    /**
     * @value No metadata yet
     * @description Title for an empty state
     */
    METADATA_EMPTY_STATE_TITLE = 'SPACES.METADATA_EMPTY_STATE_TITLE',
    /**
     * @value Office 365 group
     * @description Label to display office 365 groups.
     */
    MS_CALENDAR = 'COMMUNITIES.OFFICE_365_GROUP',
    /**
     * @value There are no members.
     * @description Displayed in the members list of a Space when there are no members yet added to the Space.
     */
    NO_MEMBERS = 'SPACES.NO_MEMBERS',
    /**
     * @value No metadata values selected
     */
    NO_METADATA_SELECTED = 'SPACES.NO_METADATA_SELECTED',
    /**
     * @value Sharepoint Drive folder
     */
    ONEDRIVE_FOLDER = 'SPACES.CONFIGURATION_ONEDRIVE_FOLDER',
    /**
     * @value Pinned posts
     * @description Post that have been pinned to the top, to be highlighted
     */
    PINNED_POSTS = 'SPACES.PINNED_POSTS',
    /**
     * @value {"one":"Pinned post","other":"Pinned posts"}
     * @description Pinned posts, to show them in the top of the list.
     */
    PINNED_POSTS_PLURAL = 'SPACES.PINNED_POSTS_PLURAL',
    /**
     * @value Scheduled posts
     * @description Section title for a page that is displaying a list of scheduled publications.
     */
    SCHEDULED_POSTS = 'SPACES.SCHEDULED_POSTS',
    /**
     * @value {"one":"You have %COUNT% scheduled post","other":"You have %COUNT% scheduled posts"}
     * @description Example:
     *
     * - You have 1 scheduled post
     * - you have 8 scheduled posts
     */
    SCHEDULED_POST_LINK = 'SPACES.SCHEDULED_POST_LINK',
    /**
     * @value Select calendar
     * @description
     * WARNING: Make sure to not translate "Space" as it is a feature name.
     */
    SELECT_CALENDAR = 'SPACES.CONFIGURATIONS_SELECT_CALENDAR',
    /**
     * @value Select a Space
     * @description 'Space' should not be translated, it's a male noun
     */
    SELECT_SPACE = 'SPACES.SELECT_SPACE',
    /**
     * @value {"one":"Space","other":"Spaces"}
     * @description "Space" should not be translated it's a feature name
     */
    SPACE_PLURAL = 'SPACES.SPACE_PLURAL',
    /**
     * @value Third-party integrations and extensions.
     */
    THIRD_PARTY_INTEGRATION = 'SPACES.CONFIGURATION_THIRD_PARTY_INTEGRATION',
    /**
     * @value Third-party services.
     */
    THIRD_PARTY_SERVICES = 'SPACES.CONFIGURATION_THIRD_PARTY_SERVICES',
}
